<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order" v-loading="loading">
      <div class="icon-close" @click="close">
          <span class="iconfont icon1">&#xe614;</span>
          <span class="iconfont icon2">&#xe606;</span>
        </div>
      <div class="box">
        <div class="quick-title">{{L.replacementList}}</div>
        <div class="line-wrap">
          <div class="line" v-for="(item,i) in allReplaceObjList" :key="item.cartLineId">
            <span class="line-text">{{item.successor}} {{L.hasPredecessorAva}}: {{item.predecessor}}</span>
            <span class="btn-replace" :class="{'forbid-click':item.done}" @click="replaceSingle(item,i)">{{L.replace}}</span>
            <div class="delete-line" v-if="item.done"></div>
          </div> 
        </div>
        <div class="btn-skip" @click="goToNext">{{doneNum==allIdList.length?L.nextStep:L.skipNextStep}}</div>
        <div class="btn-wrap" @click="replaceAll" v-if="doneNum!=allIdList.length">{{L.replaceAll}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {api_cart_replace} from '@/api/api'
import {postAction} from '@/api/tool'

export default {
  name:'Replacement',
  data() {
    return {
      loading:false,
      show:false,
      allIdList:[],
      allReplaceObjList:[],
      doneNum:0 //replace掉的数量
    }
  },
  methods:{
    open(obj){
      this.allIdList=obj.cartLineIdList
      this.allReplaceObjList=obj.replaceCheckLineVos
      this.doneNum=0
      this.show=true
    },
    close(){
      this.show=false
    },
    replaceSingle(item,i){
      if(item.done){
        return
      }
      let params = {
        cartLineIds: [item.cartLineId]
      }
      this.loading=true
      postAction(api_cart_replace,params).then(()=>{
        this.loading=false
        item.done=true
        this.$message.success(this.L.operateSuccess)
        this.$set(this.allReplaceObjList,i,item)
        this.$emit("singleReplaceFinish")
        this.doneNum++
      }).catch(()=>{
        this.loading=false
      })
    },
    replaceAll(){
      let params = {
        cartLineIds: this.allIdList
      }
      this.loading=true
      postAction(api_cart_replace,params).then(()=>{
        this.loading=false
        this.goToNext()
      }).catch(()=>{
        this.loading=false
      })
    },
    goToNext(){
      this.close()
      this.$emit('toNextStep')
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    padding:40px 0 30px 0;
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:650px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
        // background-color: red;
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .box{
      padding:0 40px;
      .quick-title{
        font-size: 16px;
        font-weight: 600;
        margin-bottom:20px;
      }
      .line-wrap{
        max-height: 400px;
        overflow: auto;
        .line{
          // background-color: pink;
          margin-bottom:10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          // text-decoration: line-through;
          .line-text{
            color:@inpNumColor;
          }
          .btn-replace{
            border:1px solid @mainColor;
            margin-left: 10px;
            padding:2px 10px;
            color:@mainColor;
            font-size: 12px;
            border-radius: 2px;
            &:extend(.transtion-time);
            &:hover{
              &:extend(.transtion-time);
              color:#fff;
              background-color: @mainColor;
              cursor: pointer;
            }
          }
          .forbid-click{
            border:1px solid @inpBorderClolr;
            background-color: @inpBorderClolr;
            color:#fff;
            cursor: not-allowed;
            &:hover{
              cursor: not-allowed;
              // &:extend(.transtion-time);
              color:#fff;
              background-color: @inpBorderClolr;
            }
          }
          .delete-line{
            position: absolute;
            left:0;
            top:50%;
            width: 100%;
            height:0.5px;
            background-color: #000;
            transform: translateY(-50%); /* 精准居中 */
          }
        }
      }
      .btn-skip{
        margin-top: 18px;
        text-align: center;
        width:100%;
        color:@mainColor;
        background-color: #fff;
        padding:8px 6px;
        box-sizing: border-box;
        border:1px solid @mainColor;
        border-radius: 2px;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          color:#fff;
          background-color:@mainColor;
          &:extend(.transtion-time);
        }
      }
      .btn-wrap{
        margin-top: 10px;
        text-align: center;
        width:100%;
        color:#fff;
        background-color: @mainColor;
        padding:8px 6px;
        box-sizing: border-box;
        border:1px solid @mainColor;
        border-radius: 2px;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          color:@mainColor;
          background-color: #fff;
          &:extend(.transtion-time);
        }
      }
    }
  }
}

</style>